import React from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import request from "../../utils/http";
import { useState } from "react";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { ProgressBar } from "baseui/progress-bar";
import enums from "../../utils/enums";
import { Tag } from "baseui/tag";
import { DateTime } from "luxon";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

const CandidateHome = (props: any) => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();
	const [candidates, setCandidates] = useState([] as any);
	const [filter, setFilter] = useState("");

	const loadCandidates = async () => {
		let result = await request(
			"GET",
			`/api/admin/candidate-moj/gc${
				props.mode === "my-moj" ? "/my" : 
				props.mode === "all-moj" ? "/all" :filter	
		}`,
			null
		);
		if (result.success && result.data) {
			setCandidates(result.data.candidates);
		}
	};

	useEffect(() => {
		loadCandidates();
	}, [urlParams]);

	return (
		<Container>
			<ActionHeader>
				{props.mode === "my-moj" ? <h1>My MOJ Checks</h1> : <h1>MOJ Checks</h1>}

				<div></div>
			</ActionHeader>
			<hr />
			<StyledTable
				role="grid"
				$gridTemplateColumns={
					props.mode === "my-moj" ? "1fr 1fr 1fr" : "1fr 1fr 1fr 1fr"
				}
			>
				<StyledTableRow role="row">
					<StyledHeadCell>Name</StyledHeadCell>
					{props.mode !== "my-moj" && (
						<StyledHeadCell>Allocated To</StyledHeadCell>
					)}
					<StyledHeadCell>Status</StyledHeadCell>
					<StyledHeadCell>Status Date</StyledHeadCell>
				</StyledTableRow>

				{candidates &&
					candidates.map((candidate: any, i: number) => {
						const striped = i % 2 === 0;
						const mojStatus = enums.candidateMojStatus.find(
							(item: any) => item.value === candidate.currentStatus
						) as any;

						return (
							<StyledTableRow
								role="row"
								onClick={() => {
									navigate({
										pathname: `/candidate-moj/${candidate.id}`,
									});
								}}
							>
								<StyledBodyCell $striped={striped}>
									{candidate.name}
								</StyledBodyCell>
								{props.mode !== "my-moj" && (
									<StyledBodyCell $striped={striped}>
										{candidate.allocatedTo}
									</StyledBodyCell>
								)}

								<StyledBodyCell $striped={striped}>
									<Tag
										closeable={false}
										kind={mojStatus.kind}
										variant={mojStatus.variant}
										overrides={{ Text: { style: { maxWidth: "" } } }}
									>
										{mojStatus.label}
									</Tag>
								</StyledBodyCell>

								<StyledBodyCell $striped={striped}>
									{DateTime.fromISO(candidate.currentStatusDateUtc, {
										zone: "utc",
									})
										.setZone("Pacific/Auckland")
										.toLocaleString(DateTime.DATETIME_MED)}{" "}
									<em>
										(
										{DateTime.fromISO(candidate.currentStatusDateUtc, {
											zone: "utc",
										})
											.setZone("Pacific/Auckland")
											.toRelative()}
										)
									</em>
								</StyledBodyCell>
							</StyledTableRow>
						);
					})}
			</StyledTable>
		</Container>
	);
};
export default CandidateHome;
